import { useDispatch } from "react-redux";
import CloseIcon from "../../assets/close.svg?react";
import { setRightPanelActiveTab, setRightPanelOpen } from "../../store/appSlice";
import { RightPanelTabs } from "../../constants/Panels";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import DataImport from "./DataImport";
import DepthDataImport from "./DepthDataImport";

const DataImportTabs = () => {

    const dispatch = useDispatch();


    const closePanel = () => {
        dispatch(setRightPanelOpen(false));
        dispatch(setRightPanelActiveTab(RightPanelTabs.UNDEFINED));
    }

    return (
        <div className={`efs-manager-container`} >
            <div className="efs-manager-header w-100 flex-row space-between">
                <h2>Dataimport</h2>
                <button type="button" className="empty-button" style={{ position: "absolute", right: "16px", top: "16px" }} onClick={closePanel}>
                    <CloseIcon />
                </button>
            </div>
            <Tabs
                style={{ height: "calc(100% - 69px)" }}
                className={`w-100 h-100 flex-col`}
                disabledTabClassName="disabled"
                selectedTabClassName="selected"
            >
                <TabList className={`panel-content-tab-list`}>
                    <Tab className={`panel-content-tab-button`} title="Kartdata">
                        Kartdata
                    </Tab>
                    <Tab className={`panel-content-tab-button`} title="Dybdedata">
                        Dybdedata
                    </Tab>
                </TabList>
                <TabPanel selectedClassName="selected" className={`panel-content-tab-panel`}>
                    <DataImport />
                </TabPanel>
                <TabPanel selectedClassName="selected" className={`panel-content-tab-panel`}>
                    <DepthDataImport />
                </TabPanel>
            </Tabs>
        </div>
    )
}

export default DataImportTabs;